import React from 'react';
import { forNamespace } from 'app/common/lib/util/i18n';
import { AlertContainer } from 'app/gamma/src/components/alert';

export const AA_MIGRATION_ALERT_AREA = 'aaMigrationAlerts';
export const AA_MIGRATION_ALERT_GENERIC = 'aaMigrationGenericAlert';

const format = forNamespace(['aa migration wizard', 'banner'], {
  shouldEscapeStrings: false,
});

/** This alert container has to be rendered outside of the scope of the Wizard,
 * since it renders in a separate Layer. Today this lives in the banner,
 * so be sure to render this if operating in a different context or refactoring.
 */
export const AtlassianAccountMigrationAlertContainer = () => (
  <AlertContainer
    displayType="error"
    area={AA_MIGRATION_ALERT_AREA}
    name={AA_MIGRATION_ALERT_GENERIC}
  >
    {format('something-went-wrong')}
  </AlertContainer>
);
